"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContactWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledContactWrapper = _styledComponents.default.div.withConfig({
  displayName: "Contactstyles__StyledContactWrapper",
  componentId: "sc-1o7vz6s-0"
})([".c-contact-mobile{display:block;@media only screen and (min-width:", "){display:none;}}.c-contact-desktop{display:none;@media only screen and (min-width:", "){display:block;}}.c-contact-hours-text{text-align:left;}.c-contact-mobile-link{margin:0;}a{text-decoration:none;}"], function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.smallBreak;
});

exports.StyledContactWrapper = StyledContactWrapper;